var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"headerNav",class:[ _vm.isFixed ? 'fixed animate__animated animate__slideInDown' : '']},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mobileHeader"},[_c('img',{staticClass:"logo",attrs:{"src":"https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/mobile/mobileLogo.png","alt":"logo"}})])])
}]

export { render, staticRenderFns }